import { render, staticRenderFns } from "./KYCInformation.vue?vue&type=template&id=09cfac53&scoped=true&"
import script from "./KYCInformation.vue?vue&type=script&lang=js&"
export * from "./KYCInformation.vue?vue&type=script&lang=js&"
import style0 from "./KYCInformation.vue?vue&type=style&index=0&id=09cfac53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cfac53",
  null
  
)

export default component.exports